// extracted by mini-css-extract-plugin
module.exports = {"mainBlock__letterContent":"letterPage_mainBlock__letterContent__2N1Un","mainBlock__paragraph":"letterPage_mainBlock__paragraph__3fdtK","close":"letterPage_close__wullZ"};